(function () {
  var selector = [
    '.home-approved-v4__benefit-video',
    '.home-approved-v4__category-media',
    '.home-approved-v4__documentary-video',
    '.product-intro-premium__viewport-video'
  ].join(',');

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var saveData = navigator.connection && navigator.connection.saveData;
  var observer;

  function pauseVideo(video) {
    video.pause();
    video.removeAttribute('autoplay');
  }

  function hydrateVideo(video) {
    if (video.dataset.viewportVideoHydrated === 'true') return;

    var sources = video.querySelectorAll('source[data-src]');
    sources.forEach(function (source) {
      source.src = source.getAttribute('data-src');
    });

    video.dataset.viewportVideoHydrated = 'true';
    if (sources.length) video.load();
  }

  function playVideo(video) {
    if (reducedMotion.matches || saveData || document.hidden) return;
    video.preload = 'metadata';
    hydrateVideo(video);
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function registerVideos(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var videos = root.querySelectorAll(selector);

    videos.forEach(function (video) {
      if (video.dataset.viewportVideoReady === 'true') return;
      video.dataset.viewportVideoReady = 'true';
      video.dataset.viewportVideoVisible = 'false';
      video.muted = true;
      video.playsInline = true;
      pauseVideo(video);

      if (reducedMotion.matches || saveData) {
        video.preload = 'none';
        return;
      }

      if (observer) observer.observe(video);
    });
  }

  function init() {
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var isVisible = entry.isIntersecting && entry.intersectionRatio >= 0.18;
          entry.target.dataset.viewportVideoVisible = isVisible ? 'true' : 'false';
          if (isVisible) {
            playVideo(entry.target);
          } else {
            pauseVideo(entry.target);
          }
        });
      }, {
        rootMargin: '0px',
        threshold: [0, 0.18, 0.6]
      });
    }

    registerVideos(document);
  }

  document.addEventListener('visibilitychange', function () {
    document.querySelectorAll(selector).forEach(function (video) {
      if (document.hidden) {
        pauseVideo(video);
      } else if (video.dataset.viewportVideoVisible === 'true') {
        playVideo(video);
      }
    });
  });

  function handleMotionPreference(event) {
    document.querySelectorAll(selector).forEach(function (video) {
      if (event.matches) {
        pauseVideo(video);
        video.preload = 'none';
      } else {
        video.preload = 'none';
        if (video.dataset.viewportVideoVisible === 'true') playVideo(video);
      }
    });
  }

  if (typeof reducedMotion.addEventListener === 'function') {
    reducedMotion.addEventListener('change', handleMotionPreference);
  } else if (typeof reducedMotion.addListener === 'function') {
    reducedMotion.addListener(handleMotionPreference);
  }

  document.addEventListener('shopify:section:load', function (event) {
    registerVideos(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
